import React, { useState } from 'react'
import { RiDeleteBinLine } from 'react-icons/ri'
import { BiEdit } from 'react-icons/bi'
import { MwSwitch } from '../ui';
import { usePut } from '../../hooks';

const PaymentMethodListItem = ({ item, description, index, confirmDeleteHandler, editHandler, apiBaseUrl }) => {
    const [isActive, setIsActive] = useState(description?.payment_method_id === item.id ? item.is_active : false);
    const { putData } = usePut();

    const onChangeSwitch = () => {
        const _data = {
            isActive: !isActive,
        };
        const baseUrl = (apiBaseUrl || process.env.REACT_APP_INV_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
        const url = baseUrl ? `${baseUrl}/payment-methods/update/${item.id}` : "";
        putData(url, _data);
    };

    return (
        <div key={index} className='w-full'>
            <div className='flex flex-col text-xs mt-3 border-b border-slate-200 p-2'>
                <div className='flex justify-between items-center'>
                    <div>{description?.name}</div>
                    <div className='flex flex-col items-center gap-2'>
                        <MwSwitch onChangeSwitch={onChangeSwitch} custKey={item?.id} isActive={isActive} setIsActive={setIsActive} />
                    </div>
                </div>
                <div className='flex justify-between text-slate-500'>
                    <div>{description?.desc}</div>
                    <div className='flex pt-2'>
                        <BiEdit onClick={() => editHandler(item)} size={14} className='my-2' />
                        <RiDeleteBinLine onClick={() => confirmDeleteHandler(item)} size={14} className='m-2' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentMethodListItem
